import { UIIcon } from '../config/icons';
import { ABFilterBar, TLNewFilterManager } from '../lib/ab/filter-bar';
import { EProducerPayoutListView, eProducerPayoutsList } from '../lib/mdl/e-payout';
import { the_alt_token, the_user } from '../lib/me/login';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIButton } from '../lib/ui/component/button';
import { UIList } from '../lib/ui/component/list';
import { $el } from '../lib/ui/elements';
import { UIScreen } from '../lib/ui/screen';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { $amount } from '../lib/y/amount';
import { $analytics } from '../lib/y/analytics';
import { $fn } from '../lib/y/fn';
import { $format } from '../lib/y/format';
import { $i18n, yInterpolate } from '../lib/y/i18n';
import { $date } from '../lib/y/time';

function getMonthStart(p: EProducerPayoutListView) {
    return $date.make(parseInt(p.month.slice(0, 4)), parseInt(p.month.slice(4, 6)) - 1, 1);
}

class PaymentCard extends UIView {
    constructor(payment: EProducerPayoutListView) {
        const start = getMonthStart(payment);
        const paid_on = payment.paid_on ? $date(payment.paid_on) : undefined;

        super('div', 'tl-producer-card m-payment', [
            $el.DIV('r-date m-month-only', [
                $el.DIV('r-month', start.format('MMM'))
            ]),
            $el.DIV('r-info', [
                $el.B(paid_on ? yInterpolate($i18n.pr.payments_paid, paid_on.format('yyyy-MM-dd')) : $i18n.pr.payments_pending),
                $el.B(yInterpolate($i18n.pr.payments_tickets, payment.quantity)),
                $el.B($format.currency(payment.amount))
            ]),
            $el.S(),
            new UIButton({ kind: 'k-square', icon: UIIcon.DOWNLOAD, classes: 'm-round m-bigger ui-tint-subtle', link: '/docs/producer_invoice/' + payment.id + '?format=pdf&token=' + the_alt_token, on_click: () => { $analytics.track('Summary Download') } })
        ]);
    }
}

export class ProducerInvoicesScreen extends UIScreen {
    private _all_invoices!: EProducerPayoutListView[];
    private _list!: UIList;
    private _filters!: TLNewFilterManager

    constructor() {
        super();
    }

    protected override async fillContent(content: UIViewSpec) {
        const all_invoices = this._all_invoices = (await eProducerPayoutsList(the_user!.country))//TODOURGENT .filter(i => i.producer_id == $tl.the_producer?.model.id);

        const all_events = new Set<string>;
        const all_years = new Set<string>();
        for(const invoice of all_invoices) {
            //TODOURGENT
            // if(invoice.items) {
            //     for(const item of invoice.items) {
            //         if(item.section == 'event') {
            //             all_events.add(item.description)
            //         }
            //     }
            // }
            const year = invoice.month.substring(0, 4);
            all_years.add(year);
        }

        const doSearch = () => this._doSearch();
        const filter_bar = new ABFilterBar({ on_filter: doSearch });
        this._filters = filter_bar.filters;
        filter_bar.filters.addSelect('event', $i18n.pr.filter_events, Array.from(all_events).sort((a, b) => $fn.ICOMPARE(a, b)).map(e => ({ key: e, name: e })), $i18n.pr.filter_events_all);
        filter_bar.filters.addSelect('year', $i18n.pr.filter_year, Array.from(all_years).sort((a, b) => $fn.ICOMPARE(b, a)).map(e => ({ key: e, name: e })), $i18n.pr.filter_year_all);

        const total = all_invoices.reduce((acc, p) => $amount.add(acc, p.amount), $amount.zero());

        content.ui_add($el.DIV('ui-section', $el.DIV('tl-new-list-block', [
            $el.P('screen-title', yInterpolate($i18n.pr.payments_title, $format.currency(total))),
            $el.P('screen-mobile-title', yInterpolate($i18n.pr.payments_mobile_title, $format.currency(total))),
            filter_bar,
            this._list = new UIList(undefined, { classes: 'tl-producer-list', progressive: true })
        ])));

        doSearch();
    }

    private _doSearch() {
        let invoices = this._all_invoices

        const filter_value = this._filters.value;
        //TODOURGENT
        // if(filter_value.event) {
        //     const event = filter_value.event;
        //     invoices = invoices.filter(i => i.items?.some(item => item.section == 'event' && item.description == event));
        // }
        if(filter_value.year) {
            const year = filter_value.year;
            invoices = invoices.filter(i => i.month.startsWith(year));
        }

        const by_year = Object.entries(Object.groupBy(invoices, i => getMonthStart(i).year)).sort((a, b) => b[0].localeCompare(a[0]));

        this._list.sections = by_year.map(e => {
            const section = new UIDataAdapter((i: EProducerPayoutListView) => new PaymentCard(i));
            section.header = $el.DIV('r-header', e[0]);
            section.data = e[1]?.sort((a, b) => getMonthStart(b).month - getMonthStart(a).month);
            return section;
        });
    }
}
